/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SalesMaterialViewSolicitorCloudSalesMaterialFragment = { id: string, title: string, pdfFilePath: string | null, youtubeUrl: string | null, publishedAt: DateTimeString, createdAt: DateTimeString, updatedAt: DateTimeString };

export type SalesMaterialViewSalesMaterialsFragment = { solicitorCloudSalesMaterials: Array<{ id: string, title: string, pdfFilePath: string | null, youtubeUrl: string | null, publishedAt: DateTimeString, createdAt: DateTimeString, updatedAt: DateTimeString }> };

export type GetSalesMaterialViewDocumentFileUrlQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type GetSalesMaterialViewDocumentFileUrlQuery = { solicitorCloudSalesMaterialsByIds: Array<{ fileUrl: string }> };

export const SalesMaterialViewSolicitorCloudSalesMaterialFragmentDoc = gql`
    fragment SalesMaterialViewSolicitorCloudSalesMaterial on SolicitorCloudSalesMaterial {
  id
  title
  pdfFilePath
  youtubeUrl
  publishedAt
  createdAt
  updatedAt
}
    `;
export const SalesMaterialViewSalesMaterialsFragmentDoc = gql`
    fragment SalesMaterialViewSalesMaterials on Query {
  solicitorCloudSalesMaterials {
    ...SalesMaterialViewSolicitorCloudSalesMaterial
  }
}
    ${SalesMaterialViewSolicitorCloudSalesMaterialFragmentDoc}`;
export const GetSalesMaterialViewDocumentFileUrlDocument = gql`
    query getSalesMaterialViewDocumentFileUrl($ids: [ID!]!) {
  solicitorCloudSalesMaterialsByIds(ids: $ids) {
    fileUrl
  }
}
    `;

/**
 * __useGetSalesMaterialViewDocumentFileUrlQuery__
 *
 * To run a query within a Vue component, call `useGetSalesMaterialViewDocumentFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesMaterialViewDocumentFileUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSalesMaterialViewDocumentFileUrlQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useGetSalesMaterialViewDocumentFileUrlQuery(variables: GetSalesMaterialViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<GetSalesMaterialViewDocumentFileUrlQueryVariables> | ReactiveFunction<GetSalesMaterialViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables>(GetSalesMaterialViewDocumentFileUrlDocument, variables, options);
}
export function useGetSalesMaterialViewDocumentFileUrlLazyQuery(variables?: GetSalesMaterialViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<GetSalesMaterialViewDocumentFileUrlQueryVariables> | ReactiveFunction<GetSalesMaterialViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables>(GetSalesMaterialViewDocumentFileUrlDocument, variables, options);
}
export type GetSalesMaterialViewDocumentFileUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSalesMaterialViewDocumentFileUrlQuery, GetSalesMaterialViewDocumentFileUrlQueryVariables>;